$(document).ready(function(){

   $(".product_gallery").find(".col-md-6").map(function(){
    let flag = false;
    $(this).find("a").map(function(){
       if($(this).css("display") == "none"){
          flag = true;
       }
    });

    if(flag){
       $(this).css("display", "none");
    }else {
       $(this).css("display", "block");
    }
})

});